export const preserveAwsUrl = (
  prevUrl: string | null | undefined,
  newUrl: string | null | undefined,
  onRevokeBlobUrl?: (url: string) => void
): string | null | undefined => {
  if (!prevUrl) return newUrl;

  if (newUrl) {
    const prevBaseUrl = prevUrl.split('?')[0];
    const newBaseUrl = newUrl.split('?')[0];

    if (prevBaseUrl === newBaseUrl) {
      return prevUrl;
    }
  }

  if (onRevokeBlobUrl && prevUrl.startsWith('blob:')) {
    onRevokeBlobUrl(prevUrl);
  }

  return newUrl;
};
